import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'upperCamelCase'
})
export class UpperCamelCasePipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '';

    return value
      .split(' ')  // Split the string into words
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
      .join(' '); // Join the words together without spaces
  }
}
